module.exports = __webpack_public_path__ + "img/link-solid.14d97753.svg";